<template>
  <div id="app">
    <top-navigation style="z-index: 1111 !important; position: fixed" v-if="rotated" :show-avatar="false" :close-game-alt="true" :show-back="false" :show-home="false" :show-full-screen="false" :show-reload="true"></top-navigation>
    <router-view/>
    <b-modal class="screen-orientation" centered hide-footer no-close-on-esc no-close-on-backdrop size="lg" ref="modalScreenOrientation" id="error-modal" hide-header>
      Please rotate your device to landscape
      <br />
      <div class="rotate-img middle">
        <img src="./assets/img/rotate.png">
      </div>
    </b-modal>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import screenfull from 'screenfull'
import TopNavigation from './components/TopNavigation'

export default {
  name: 'App',
  components: { TopNavigation },
  data () {
    return {
      rotated: false
    }
  },
  mounted () {
    let lastTouchEnd = 0
    document.addEventListener('gesturestart', e => {
      e.preventDefault()
    })

    document.addEventListener('touchend', (event) => {
      let now = (new Date()).getTime()
      if (now - lastTouchEnd <= 300) {
        event.preventDefault()
      }
      lastTouchEnd = now
    }, false)

    window.scrollTo(0, 1)

    const screenOrientationCheck = () => {
      if (window.screen.orientation) {
        if (!window.screen.orientation.type.includes('landscape')) {
          this.$refs.modalScreenOrientation.show()
          this.rotated = true
        } else {
          if (screenfull.enabled && window.isMobile) {
            // screenfull.request()
            window.screen.orientation.lock(window.screen.orientation.type)
            window.scrollTo(0, 1)
          }
          this.$refs.modalScreenOrientation.hide()
          this.rotated = false
        }
      } else {
        if (window.orientation === 0 || window.orientation === 180) {
          this.$refs.modalScreenOrientation.show()
          this.rotated = true
        } else {
          this.$refs.modalScreenOrientation.hide()
          this.rotated = false
        }
      }
    }

    screenOrientationCheck()

    const iOS = navigator.userAgent.match(/(iPod|iPhone|iPad)/) !== null
    if (iOS) {
      window.onresize = screenOrientationCheck
    } else {
      window.addEventListener('orientationchange', screenOrientationCheck)
    }

    // const android = navigator.userAgent.match(/(Android)/) !== null
    window.isMobile = navigator.userAgent.match(/(Android|iPod|iPhone|iPad)/) !== null

    this.loadQuestions()
    this.loadAnimals()
    this.loadHideAndSeek()
    this.loadFacts()
    this.loadCards()
    if (!['/intro', '/avatar', '/'].includes(this.$route.path) && this.uid.length === 0) {
      this.$router.push('/avatar')
    }
    this.$router.beforeEach((to, from, next) => {
      window.scrollTo(0, 1)
      if (!['/intro', '/avatar', '/'].includes(to.path) && this.uid.length === 0) {
        this.$router.push('/avatar')
      } else {
        next()
      }
    })
  },
  methods: {
    ...mapActions(['loadQuestions', 'loadAnimals', 'loadHideAndSeek', 'loadFacts', 'loadCards'])
  },
  computed: {
    ...mapGetters(['uid'])
  }
}
</script>

<style>
  body {
    background-color: #000 !important;
  }
</style>
